import {
  ProductivityAction,
  ProductivityState,
} from 'pages/Productivity/_store';
import * as R from 'remeda';
import { timeUtility } from 'utility';

// Initial selection defaults to yesterday and its containing week — productivity
// data is typically reviewed after the day has closed.
const selectedDay = timeUtility.step({
  timeDate: timeUtility.getToday(),
  step: 'previous',
  stepSize: 'day',
});
const selectedWeek = timeUtility.convertDay('week', selectedDay) as Time.Week;

const initialState: ProductivityState = {
  selectedWeek,
  selectedDay: selectedDay!,
  pivotById: {},
};

const productivityReducer = (
  state: ProductivityState = initialState,
  action: ProductivityAction,
): ProductivityState => {
  switch (action.type) {
    // Toggle a row's expanded/pivoted state in the pivot table.
    case 'page/productivity/TOGGLE_PIVOT': {
      let pivotById = R.clone(state.pivotById);

      const pivotted = R.isTruthy(pivotById[action.payload.id]);
      if (pivotted) pivotById = R.omit(pivotById, [action.payload.id]);
      else pivotById[action.payload.id] = true;

      return R.set(state, 'pivotById', pivotById);
    }

    case 'page/productivity/SET_SELECTED_WEEK': {
      const selectedWeek = action.payload;
      return R.set(state, 'selectedWeek', selectedWeek);
    }
    case 'page/productivity/SET_SELECTED_DAY': {
      const selectedDay = action.payload;
      return R.set(state, 'selectedDay', selectedDay);
    }

    default:
      return state;
  }
};

export default productivityReducer;
